<template>
  <module-box
    type="character-profile"
    :mode="mode"
    :moduleData="moduleData"
    showSetup
    @onSetup="handleOpenModuleSetupPanel"
    @onDelete="handleDeleteModule"
    @onMore="handleMore"
  >
    <div class="cheracter-profile" v-if="moduleData">
      <module-title :mode="mode" :title="moduleData.title" @onChange="handleTitleChange"></module-title>
      <div class="container">
        <div class="cheracter-profile-main">
          <div class="image-album" v-if="moduleData.isShowImageList">
            <image-album
              :mode="mode"
              :imgs="moduleData.imageList"
              :imageSize="moduleData.imageSize"
              @onResize="handleResize"
              @onChange="handleImageListChange"
            ></image-album>
          </div>
          <div class="info-main">
            <div class="name" v-if="moduleData.isShowName">
              <text-box
                type="editor"
                :mode="mode"
                :image-style="{ height: '30px' }"
                :value="moduleData.name"
                @onChange="handleNameChange"
              >
                {{ moduleData.name }}
              </text-box>
            </div>
            <div v-if="moduleData.isShowAttrList && moduleData.attrList">
              <template v-if="moduleData.attrList.length > 0">
                <draggable
                  class="attr-list"
                  v-model="attrList"
                  :animation="200"
                  :group="'characterProfileAttrList'"
                  :disabled="mode !== 'edit'"
                  :ghostClass="'ghost'"
                  :handle="'.edit-drag'"
                  @start="dragAttr = true"
                  @end="dragAttr = false"
                  @change="handleSortAttr"
                >
                  <div
                    class="item-box"
                    v-for="(attr, index) in attrList"
                    :style="{
                      width: attr.isOneLine ? '100%' : 'calc(50% - 23px)'
                    }"
                    :key="attr.key"
                  >
                    <attr-box
                      :mode="mode"
                      :data="attr"
                      @onAdd="handleAddAttr(index)"
                      @onDelete="handleDeleteAttr(index)"
                      @onChange="data => handleAttrChange(index, data)"
                    ></attr-box>
                  </div>
                </draggable>
              </template>
              <template v-else-if="mode == 'edit'">
                <button class="add-btn" @click.stop="handleAddAttr">
                  <i class="icon wiki-editable-add"></i>
                </button>
              </template>
            </div>
          </div>
        </div>
        <div class="cheracter-profile-desc" v-if="moduleData.isShowDesc && moduleData.desc">
          <div class="title">
            <text-box
              type="editor"
              :mode="mode"
              :image-style="{ height: '22px' }"
              :value="moduleData.descTitle || '个人简介'"
              @onChange="handleDescTitleChange"
            >
              {{ moduleData.descTitle || "个人简介" }}
            </text-box>
          </div>
          <div class="desc">
            <text-box
              type="editor"
              :mode="mode"
              :image-style="{ height: '50px' }"
              :value="moduleData.desc"
              @onChange="handleDescChange"
            >
              {{ moduleData.desc }}
            </text-box>
          </div>
        </div>
      </div>
    </div>
    <!-- 设置 -->
    <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="moduleData" @onChange="handleChangeData"></setup-panel>
  </module-box>
</template>

<script>
import draggable from "vuedraggable";
// components
import ModuleBox from "../../components/ModuleBox";
import ImageAlbum from "./components/ImageAlbum";
import AttrBox from "./components/Attrbox";
import TextBox from "../../components/TextBox";
import ModuleTitle from "../../components/ModuleTitle";
import SetupPanel from "./SetupPanel";

export default {
  name: "CharacterProfile",
  components: {
    draggable,
    ModuleBox,
    ImageAlbum,
    TextBox,
    AttrBox,
    ModuleTitle,
    SetupPanel
  },
  props: {
    mode: String,
    moduleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      attrList: this.moduleData.attrList || [],
      dragAttr: false
    };
  },
  watch: {
    moduleData(val) {
      this.attrList = val.attrList;
    }
  },
  mounted() {},

  methods: {
    // 模块更多操作
    handleMore(command, data) {
      if (command === "copy") {
        const moduleData = JSON.parse(JSON.stringify(this.moduleData));
        this.$emit("onCopy", moduleData);
      }
    },
    // 模块设置
    handleOpenModuleSetupPanel() {
      this.$refs.setupPanel.open();
    },
    handleChangeData(data) {
      this.$emit("onChange", data);
    },
    // 模块删除
    handleDeleteModule() {
      this.$emit("onDelete");
    },
    // 图片
    handleResize(width, height) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.imageSize = {
        width: width || "160px",
        height: height || "160px"
      };
      this.$emit("onChange", moduleData);
    },
    // 标题编辑
    handleTitleChange(title) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.title = title;
      this.$emit("onChange", moduleData);
    },
    // 图片列表编辑
    handleImageListChange(imageList) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.imageList = imageList;
      this.$emit("onChange", moduleData);
    },
    // name编辑
    handleNameChange(name) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.name = name;
      console.log(111);
      this.$emit("onChange", moduleData);
    },
    // 简介标题编辑
    handleDescTitleChange(descTitle) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.descTitle = descTitle;
      this.$emit("onChange", moduleData);
    },
    // 简介编辑
    handleDescChange(desc) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.desc = desc;
      this.$emit("onChange", moduleData);
    },
    // 属性排序
    handleSortAttr() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.attrList = this.attrList;
      this.$emit("onChange", moduleData);
    },
    // 属性编辑
    handleAttrChange(dataIndex, data) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      console.log(data)
      moduleData.attrList.splice(dataIndex, 1, data);
      this.$emit("onChange", moduleData);
    },
    // 属性添加
    handleAddAttr(dataIndex = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.attrList.splice(dataIndex + 1, 0, {
        key: Math.random().toString(16),
        isOneLine: false,
        isWapOneLine: true,
        title: "",
        content: ""
      });
      this.$emit("onChange", moduleData);
    },
    // 属性删除
    handleDeleteAttr(dataIndex = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.attrList.splice(dataIndex, 1);
      this.$emit("onChange", moduleData);
    }
  }
};
</script>

<style lang="less" scoped>
.cheracter-profile {
  width: 100%;
  .container {
    padding: 22px 25px 12px 25px;
  }
  .cheracter-profile-main {
    display: flex;
    .image-album {
      flex-shrink: 0;
      margin-right: 24px;
      margin-bottom: 24px;
    }
    .info-main {
      width: 100%;
      .name {
        width: 100%;
        height: 30px;
        font-size: 20px;
        font-weight: bold;
        color: #373737;
        line-height: 30px;
        margin-bottom: 12px;
        padding: 0 15px;
      }
      .attr-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0 46px;
        .item-box {
          margin-bottom: 8px;
          width: calc(50% - 23px);
        }
      }
    }
  }

  .add-btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }

  .cheracter-profile-desc {
    width: 100%;
    padding-top: 25px;
    border-top: 1px solid rgba(0, 0, 0, 0.11);
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #212121;
      line-height: 22px;
      margin-bottom: 12px;
    }

    .desc {
      min-height: 22px;
      font-size: 14px;
      font-weight: 400;
      color: #373737;
      line-height: 22px;
    }
  }
}
</style>
